const CONFIG = {
  SystemWeb: "ODBLWeb",

  System: "ODBL",

  SystemDesc: "國泰60周年",

  API_URL: window.location.protocol + "//" + window.location.host,

  API_DISPATCHER: "/api",

  USER_URL: "/login",

  LOGOUT_URL: "/logout",

  NODE_ENV_DISPLAY: {
    DEV: "development",
    TEST: "testing",
    STAG: "staging",
    PROD: "production"
  },

  INIT() {
    if (process.env.NODE_ENV == CONFIG.NODE_ENV_DISPLAY.DEV) {
      CONFIG.API_URL = "/static/data";
    } else {
      CONFIG.API_URL += "/" + CONFIG.SystemWeb + CONFIG.API_DISPATCHER;
    }

    // setting logout url.
    if (process.env.VUE_APP_API_HOST != "/") {
      CONFIG.LOGOUT_URL = process.env.VUE_APP_API_HOST + CONFIG.LOGOUT_URL;
    }
  }
};

export default CONFIG;
